import React, { useState, useEffect } from 'react';
import Form from './Form';
import { useShoppingCart } from '../../../context/CartContext.tsx/ShoppingCartContext';
import CartLoader from '../../../components/CartLoader';
import axios from 'axios';
import { addShippingInfoEvent, pushCartItem } from '../../../utils/GoogleAnalytics';


interface AddressFormProps {
    setOpenForm?: React.Dispatch<React.SetStateAction<boolean>> | any;
    selectedAddress?: any;
}

const AddressForm = ({ setOpenForm, selectedAddress = {} }: AddressFormProps) => {



    const { updateCustomerAddress, getCartData, isCartLoadingData, gerCartError, setAddressToggleData, setAddressToggle,  closePopup,
        setPageData,modalOpenData } = useShoppingCart();
    const data = getCartData;
    let customer_phone: any = '';
    // customer_phone = data?.data[0].customer.phone;
    // console.log(data?.data[0].customer.phone, 'data?.data[0].customer.phone')
    if (data?.data[0].customer.phone) {
        customer_phone = data?.data[0].customer.phone;
        customer_phone = customer_phone.toString();
        customer_phone = customer_phone.slice(-10);
    } else {
        customer_phone = '';
    }
    const [formData, setFormData] = useState({
        first_name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        zip: '',
        province: '',
        country: 'India',
        country_code: 'IN',
        is_default: 1,
        category: 'home',
        id:''
    });

    useEffect(() => {
        if (selectedAddress) {
            setFormData(selectedAddress);
        } else {
            setFormData({
                first_name: '',
                email: '',
                phone: customer_phone,
                address: '',
                city: '',
                zip: '',
                province: '',
                country: 'India',
                country_code: 'IN',
                is_default: 1,
                category: 'home',
                id:''
            });
        }
    }, [selectedAddress]);

    const isFormValid = () => {
        const isValidZip = /^\d{6}$/.test(formData.zip); // Check if zip code is a 6-digit number
        return (
            formData.first_name !== '' &&
            isValidEmail(formData.email) &&
            formData.phone !== '' &&
            formData.address !== '' &&
            isValidZip &&
            formData.city !== '' &&
            formData.province !== '' &&
            formData.phone.length === 10
        );
    };

    const isValidEmail = (email: string) => {
        // Basic email validation using a regular expression
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };


    // console.log(formData)



    const fetchAddressDetails = async (zip:any) => {
        // console.log(zip)
        if (formData.zip.length === 6) {
            try {
                const response = await axios.get(`https://backend.aqualens.in/lenskart/check-pincode/${zip}`);
                const { city, state } = response.data.result; // Extract city and state from the API response
                setFormData((formData) => ({
                    ...formData,
                    city: city ? city.toUpperCase() : '',
                    province: state ? state.toUpperCase() : '',
                }));
            } catch (error) {
                console.error('Error fetching address details:', error);
            }
        }
    };

    // let addressDetailsFetched = false;
    // if (formData.zip.length === 6 && !addressDetailsFetched) {
    //   fetchAddressDetails(formData.zip);
    //   addressDetailsFetched = true;
    // }

    useEffect(() => {
        if (formData.zip.length === 6 && !setAddressToggleData) {
          fetchAddressDetails(formData.zip);
          setAddressToggle(true);
        }
      }, [formData.zip, setAddressToggleData]);
    

      let currentURL = "";
      // Accessing the URL
      currentURL = window.location.href;
    //   console.log(currentURL, "thankyou");
      function retryOrder() {
        // Redirect to the previous URL
        window.history.back();
      }


      const tempCartItems:any = data?.data[0]?.temp_cart_items;
      let cart_item_array:any = [];
      const cartItemsEvent = pushCartItem(tempCartItems, cart_item_array);
    //   console.log(cartItemsEvent,'576');
    
    
    return (
        <>
                   <button
          className="popupClose"
          onClick={() => {
            if (modalOpenData.popupId === "checkout") {
              closePopup();
              setPageData(1);
            } else if (currentURL.includes("thankyou")) {
              retryOrder();
              setPageData(1);
            } else {
              closePopup();
            }
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.99032 0.990242C1.79139 0.990294 1.59699 1.04967 1.43198 1.16079C1.26697 1.2719 1.13884 1.4297 1.06399 1.61401C0.98913 1.79832 0.970941 2.00077 1.01175 2.19548C1.05255 2.39018 1.15049 2.56829 1.29305 2.70704L6.58602 8.00001L1.29305 13.293C1.19708 13.3851 1.12046 13.4955 1.06767 13.6176C1.01489 13.7397 0.987001 13.8712 0.985647 14.0042C0.984294 14.1373 1.0095 14.2692 1.05979 14.3924C1.11008 14.5156 1.18444 14.6275 1.27852 14.7216C1.3726 14.8157 1.4845 14.89 1.60768 14.9403C1.73086 14.9906 1.86283 15.0158 1.99587 15.0144C2.12891 15.0131 2.26034 14.9852 2.38247 14.9324C2.5046 14.8796 2.61497 14.803 2.70712 14.707L8.00008 9.41407L13.2931 14.707C13.3852 14.803 13.4956 14.8796 13.6177 14.9324C13.7398 14.9852 13.8713 15.0131 14.0043 15.0145C14.1373 15.0158 14.2693 14.9906 14.3925 14.9403C14.5157 14.89 14.6276 14.8157 14.7217 14.7216C14.8157 14.6275 14.8901 14.5156 14.9404 14.3924C14.9907 14.2692 15.0159 14.1373 15.0145 14.0042C15.0132 13.8712 14.9853 13.7397 14.9325 13.6176C14.8797 13.4955 14.8031 13.3851 14.7071 13.293L9.41415 8.00001L14.7071 2.70704C14.8516 2.56658 14.9503 2.38574 14.9903 2.18822C15.0302 1.9907 15.0096 1.78571 14.931 1.60013C14.8525 1.41454 14.7197 1.25701 14.5501 1.14818C14.3805 1.03935 14.182 0.984302 13.9806 0.990242C13.7208 0.997983 13.4742 1.10656 13.2931 1.29298L8.00008 6.58595L2.70712 1.29298C2.61393 1.19718 2.50248 1.12104 2.37937 1.06904C2.25625 1.01704 2.12396 0.99025 1.99032 0.990242Z"
              fill="#4F4F4F"
            ></path>
          </svg>
        </button>
            <div className="modalContent_mt" style={{ overflow: 'auto', zIndex: 1 }}>
                <div className="addressForm" style={{ paddingBottom: '90px' }}>
                    <h2 className="addressFormHeading">We are packing your fresh look!</h2>
                    <p className="addressFormSubHeading">Share your address so we can deliver your order!</p>

                    <h2 className="enterAddressHeading">Enter Your Address</h2>
                    {/* <p className="addressFormSubHeading">
                        Information provided here will be used to contact you for delivery updates
                    </p> */}

                    <Form formData={formData} setFormData={setFormData} setPin={fetchAddressDetails} />
                </div>
            </div>


            <div className='placeOrder'>
                {gerCartError && <div className='errorMessage'>{gerCartError}</div>}
                <div style={{ position: 'relative' }}>
                    {isCartLoadingData && <CartLoader />}
                    <button className="placeOrderCTA ripple" onClick={() => { updateCustomerAddress(formData); addShippingInfoEvent(cartItemsEvent); }} disabled={!isFormValid()} >
                        <span>Save My Address</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default AddressForm;




// import React, { useState } from 'react'
// import Form from './Form';

// interface AddressFormProps {
//     setOpenForm: React.Dispatch<React.SetStateAction<boolean>>
// }

// const AddressForm = ({ setOpenForm }: AddressFormProps) => {

//     const [formData, setFormData] = useState({
//         first_name: "",
//         last_name: "",
//         email: "",
//         phone: "",
//         address: "",
//         city: "",
//         zip: "",
//         province: "",
//         country_code: "",
//         is_default: 1,
//         category: "home"

//     });



//     return (
//         <>
//             <div className="titleCloseBtn">
//                 <button style={{ left: '25px', position: 'fixed', margin: '25px 0' }} onClick={() => { setOpenForm(false); }}>
//                     <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M9 15L2 8L9 1" stroke="#1B1B1B" strokeWidth="2" strokeLinecap="round" />
//                     </svg>

//                 </button>
//             </div>
//             <div className='mt-16'>
//                 <div className='addressForm'>
//                     <h2 className='addressFormHeading'>We are packing your fresh look!</h2>
//                     <p className='addressFormSubHeading'>Share your address so we can deliver your order!</p>

//                     <h2 className='enterAddressHeading'>Enter Your Address</h2>
//                     <p className='addressFormSubHeading'>Information provided here will be used to contact you for delivery updates</p>

//                     <Form formData={formData} setFormData={setFormData} />
//                 </div>

//             </div>
//         </>
//     )
// }

// export default AddressForm


